import { useAnimation } from "framer-motion";
import { useTheme } from "styled-components";
import { CloseLinear } from "../../../Iconsax/CloseLinear.js";
import { ICONSAX_SIZE } from "../../../Iconsax/Iconsax.types.js";
import { TextSize, TextWeight } from "../../../Text/Text.types.js";
import { variants } from "./animations.js";
import { AnimatedCustomText, CloseAllToastsOuter } from "./styles.js";
import { CloseAllToastsProps } from "./types.js";

export const CloseAllToasts = ({ onClose, text }: CloseAllToastsProps) => {
    const theme = useTheme();
    const controls = useAnimation();

    return (
        <CloseAllToastsOuter onClick={onClose} onMouseEnter={() => controls.start("visible")} onMouseLeave={() => controls.start("hidden")}>
            <AnimatedCustomText
                animate={controls}
                variants={variants}
                initial="hidden"
                transition={{ duration: 0.175 }}
                color={theme.grayscale[80]}
                weight={TextWeight.SEMIBOLD}
                size={TextSize["X-SMALL"]}
            >
                {text}
            </AnimatedCustomText>

            <CloseLinear size={ICONSAX_SIZE.SMALL} color={theme.colors.error[100]} />
        </CloseAllToastsOuter>
    );
};
